var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27953 12.9572H5.70392H6.35676H6.49775V9.70525H5.43421C5.16449 9.70525 5.00511 9.39875 5.16449 9.17807L7.23335 6.31538C7.36514 6.13148 7.63792 6.13148 7.76972 6.31538L9.83858 9.17807C9.99796 9.39875 9.84164 9.70525 9.56886 9.70525H8.50531V12.9572H8.6463H9.29914H12.1097C13.7188 12.8683 15 11.3634 15 9.73283C15 8.60799 14.3901 7.62719 13.4859 7.09695C13.5687 6.87321 13.6116 6.63414 13.6116 6.38281C13.6116 5.23344 12.6829 4.30476 11.5335 4.30476C11.2852 4.30476 11.0462 4.34767 10.8224 4.43042C10.1573 3.02053 8.72293 2.0428 7.05558 2.0428C4.89783 2.04587 3.12015 3.69789 2.91786 5.80353C1.25971 6.08857 0 7.62413 0 9.36197C0 11.2193 1.44667 12.8285 3.27953 12.9572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.84da9341.svg";
export { ForwardRef as ReactComponent };